import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { AppRoutingModule } from 'src/app/app-routing.module';

@NgModule({
  imports: [CommonModule, AppRoutingModule],
  declarations: [AlertComponent],
  exports: [AlertComponent]
})
export class AlertModule { }
